<!-- <div class="blue_header">
  <h1 class="heading">Manage Vehicle</h1>
</div> -->
<div class="container-fluid myIndex">
  <div
    class="col-md-12"
    *ngIf="isLoading"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99;
    "
  >
    <app-busy [message]="message"></app-busy>
  </div>

  <br />

  <div class="table-responsive">
    <table class="table custom_table">
      <thead class="" style="background: white !important; border-top: none">
        <tr class="hd-clpse">
          <th
            class="bfr-end-col"
            *ngIf="isMyVehicles && selectedVehicles.length > 0"
          ></th>

          <th data-column class="bfr-end-col">Vin</th>

          <th data-column class="bfr-end-col">Country of registration</th>
          <th data-column class="bfr-end-col">Vehicle Type</th>
          <th data-column class="bfr-end-col">Registration Number</th>

          <th data-column class="bfr-end-col">eNatis Number</th>
          <th data-column class="bfr-end-col" class="text-right">
            Licence Expiry Date
          </th>
          <th data-column class="bfr-end-col">GVM</th>
          <th data-column class="bfr-end-col">Seating Capacity</th>
          <th data-column class="bfr-end-col">Road Worthiness</th>
          <th data-column class="bfr-end-col">Depot</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr class="tbl-row" *ngFor="let item of vehicleRes; let idx = index">
          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.vin }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.vin }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry != null">
            <ng-container *ngFor="let cnt of ddlCountries">
              <span *ngIf="item.VehicleEntry.country_id == cnt.id">{{
                cnt.desc
              }}</span>
            </ng-container>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <ng-container *ngFor="let cnt of ddlCountries">
              <span *ngIf="item.country_id == cnt.id">{{ cnt.desc }}</span>
            </ng-container>
          </td>
          <td data-column>{{ item.vehicle_type }}</td>
          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.registration_number }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.registration_number }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry != null">
            {{ item.VehicleEntry.vehicle_register_num }}
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            {{ item.vehicle_register_num }}
          </td>
          <td data-column *ngIf="item.VehicleEntry != null" class="text-right">
            <span>{{
              item.VehicleEntry.date_license_expiry | date : "dd/MM/yyyy"
            }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null" class="text-right">
            <span>{{ item.date_license_expiry | date : "dd/MM/yyyy" }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.gvn }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.gvn }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.seating_capacity }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.seating_capacity }}</span>
          </td>

          <td data-column *ngIf="item.VehicleEntry != null">
            <span>{{ item.VehicleEntry.roadworthy_status }}</span>
          </td>
          <td data-column *ngIf="item.VehicleEntry == null">
            <span>{{ item.roadworthy_status }}</span>
          </td>
          <td data-column>
            <span>{{ item.Depot?.name }}</span>
          </td>
          <td data-column>
            <button
              type="button"
              id="actionView"
              class="btn_icon"
              aria-label="View file"
              (click)="actionClicked(item)"
              value="0"
            >
              <img src="assets/visibility.png" alt="" style="width: 28px" />
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small" style="color: #274c9c !important"
              ><b>No vehicle entries found. Please add a new vehicle.</b></span
            >
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="col-md-12" *ngIf="isMyVehicles">
      <button
        title="Back"
        type="button"
        (click)="onBack()"
        class="btn btn-md btn-primary pull-right"
        style="
          margin-left: 10px;
          background-color: white !important;
          color: #1d3f94 !important;
        "
      >
        Close
      </button>
    </div>
  </div>

  <!--ADD EDIT VIEW Modal -->
  <button
    data-dismiss="modal"
    title="Edit a vehicle"
    class="btn-add btn btn-primary btn-sm"
    data-toggle="modal"
    id="actionAddVehicle"
    data-target="#addEdit"
    id="myButton"
    hidden="true"
  >
    Edit Vehicle
  </button>
  <div
    class="modal fade"
    id="addEdit"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLongTitle"
    data-backdrop="false"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" *ngIf="isViewData == true">
            Vehicle Details
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            #closebutton
            aria-label="Close"
            (click)="close()"
            id="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-xl">
          <div
            class="col-md-12"
            *ngIf="isVehicleLoading"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 99;
            "
          >
            <app-busy [message]="message"></app-busy>
          </div>
          <form [formGroup]="myForm">
            <div class="contact-details opensans-semi-bold-sapphire-30px">
              <span class="opensans-semi-bold-sapphire-30px"
                >Vehicle Details</span
              >
            </div>
            <div class="rectangle-34"></div>
            <br />

            <!-- 1st Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Country of Vehicle Registration<a class="red-asterik">*</a>
                </label>

                <select
                  class="form-control form-control-sm"
                  #country_id
                  name="country_id"
                  #countryId
                  [attr.disabled]="disallowEdit ? '' : null"
                >
                  <!-- (change)="changeCountry(countryId)" -->
                  <!-- <option value="" disabled>Select country</option> -->
                  <option
                    *ngFor="let country of ddlCountries"
                    [value]="country.id"
                    [selected]="country.desc == selectedCountry"
                  >
                    {{ country.desc }}
                  </option>
                </select>
              </div>

              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  VIN or Chassis Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  #vin
                  (keyup)="checkVin(vin.value)"
                  (onpaste)="checkVin(vin.value)"
                  class="form-control input-sm form-control-sm"
                  id="vin"
                  name="vin"
                  formControlName="vin"
                  [readOnly]="isViewData || disallowEdit"
                  oninput="this.value = this.value.toUpperCase()"
                />
              </div>
            </div>
            <br />

            <!-- 3rd Row -->
            <div class="row">
              <!-- <div class="col-4 sp-fld" *ngIf="found == false"> -->
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Vehicle Registration Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  #reg
                  maxlength="20"
                  class="form-control input-sm form-control-sm"
                  formControlName="registration_number"
                  [readonly]="isViewData || eNatisResult"
                />
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Engine Number<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  id="engine_number"
                  name="engine_number"
                  formControlName="engine_number"
                  [readonly]="isViewData || eNatisResult"
                />
              </div>
            </div>
            <br />

            <!-- 4th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Seating Capacity<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  (keypress)="numberOnly($event)"
                  id="seating_capacity"
                  name="seating_capacity"
                  formControlName="seating_capacity"
                  [readonly]="isViewData || eNatisResult"
                />
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat"></label>
                <label class="control-label hd-cat">
                  Registration Year<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  id="registration_year"
                  placeholder="yyyy"
                  name="registration_year"
                  formControlName="registration_year"
                  class="form-control input-sm form-control-sm"
                  [readonly]="isViewData || eNatisResult"
                />
              </div>
            </div>
            <br />

            <!-- 5th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <div class="algn">
                  <label for="roadworthy_status"
                    >Roadworthy Status<a class="red-asterik">*</a></label
                  >
                  <input
                    type="text"
                    *ngIf="eNatisResult != null"
                    class="form-control input-sm form-control-sm"
                    id="roadworthy_status"
                    name="roadworthy_status"
                    formControlName="roadworthy_status"
                    [readonly]="eNatisResult"
                  />
                  <select
                    (change)="checkRoadworthy($event)"
                    type="text"
                    id="roadworthy_status"
                    *ngIf="eNatisResult == null"
                    name="roadworthy_status"
                    formControlName="roadworthy_status"
                    class="form-control-sm"
                    style="width: 100%; display: block"
                    [attr.disabled]="eNatisResult ? '' : null"
                  >
                    <option value="" selected disabled>Select status</option>
                    <option value="Roadworthy">Roadworthy</option>
                    <option value="Unroadworthy">Not roadworthy</option>
                  </select>
                </div>
              </div>

              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Gross Vehicle (GVM)<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  (keypress)="numberOnly($event)"
                  id="gvn"
                  name="gvn"
                  formControlName="gvn"
                  [readonly]="isViewData || eNatisResult"
                />
              </div>
            </div>
            <br />

            <!-- 6th Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  Vehicle Type<a class="red-asterik">*</a>
                </label>
                <select
                  class="form-control form-control-sm"
                  id="vehicle_type_id"
                  name="vehicle_type_id"
                  formControlName="vehicle_type_id"
                >
                  <option value="" disabled selected>
                    Select vehicle type
                  </option>
                  <option *ngFor="let type of vehicletypes" [ngValue]="type.id">
                    {{ type.description }}
                  </option>
                </select>
              </div>
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat">
                  License Expiry Date<a class="red-asterik">*</a>
                </label>
                <input
                  type="text"
                  class="form-control input-sm form-control-sm"
                  [readonly]="isViewData || eNatisResult"
                  [minDate]="currentDate"
                  ngbDatepicker
                  #d5="ngbDatepicker"
                  placeholder="dd/mm/yyyy"
                  (click)="d5.toggle()"
                  id="date_license_expiry"
                  name="date_license_expiry"
                  formControlName="date_license_expiry"
                />
              </div>

              <div class="col-4 sp-fld">
                <label class="control-label hd-cat"></label>
              </div>
            </div>

            <!--Row -->
            <div class="row">
              <div class="col-6 sp-fld">
                <label class="control-label hd-cat"> Belonging Depot </label>
                <select
                  class="form-control form-control-sm"
                  #depot_id
                  name="depot_id"
                  formControlName="depot_id"
                  [attr.disabled]="disallowEdit ? '' : null"
                >
                  <option
                    *ngFor="let depot of ddlDepots"
                    [value]="depot.id"
                    [selected]="depot.name == selectedDepot"
                  >
                    {{ depot.name }}
                  </option>
                </select>
              </div>
              <div class="col-4 sp-fld">
                <div class="algn">
                  <label for="is_leased"
                    >Is the vehicle leased?<a class="red-asterik">*</a></label
                  >
                  <select
                    type="text"
                    id="is_leased"
                    name="is_leased"
                    formControlName="is_leased"
                    class="form-control-sm"
                  >
                    <!-- (change)="LeaseChange($event)" -->
                    <option value="" disabled selected>Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </div>

            <br />

            <!-- 7th Row -->
            <div class="row">
              <ng-container *ngIf="leased == 'true' || leased == true">
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Lessor Name<a class="red-asterik">*</a>
                  </label>
                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="vehicle_lessor"
                    name="vehicle_lessor"
                    formControlName="vehicle_lessor"
                    [readonly]="isViewData"
                  />
                </div>
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Lessee Name<a class="red-asterik">*</a>
                  </label>

                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="vehicle_lessee"
                    name="vehicle_lessee"
                    formControlName="vehicle_lessee"
                    [readonly]="isViewData"
                  />
                  <div
                    class="form-control-feedback text-danger text-small"
                  ></div>
                </div>
                <div class="col-4 sp-fld">
                  <label class="control-label hd-cat">
                    Expiry Date Of Lease<a class="red-asterik">*</a>
                  </label>
                  <input
                    type="text"
                    class="form-control input-sm form-control-sm"
                    id="date_lease_expiry"
                    placeholder="dd/mm/yyyy"
                    [placement]="'top'"
                    [minDate]="currentDate"
                    ngbDatepicker
                    #d5="ngbDatepicker"
                    (click)="d5.toggle()"
                    name="date_lease_expiry"
                    formControlName="date_lease_expiry"
                  />
                </div>
              </ng-container>
            </div>
            <br />
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            (click)="CloseModal()"
            *ngIf="isViewData == true"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
